import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/cn';

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  variant?: 'default' | 'sunk';
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
}

export function Card({
  variant = 'default',
  title,
  description,
  actions,
  className,
  children,
  ...rest
}: CardProps): JSX.Element {
  return (
    <div
      {...rest}
      className={cn(
        'rounded-surface border border-rule p-5',
        variant === 'sunk' ? 'bg-paper-soft' : 'bg-paper',
        className,
      )}
    >
      {(title || description || actions) && (
        <div className="mb-4 flex items-start justify-between gap-4">
          <div className="min-w-0">
            {title ? (
              <h3 className="text-[17px] font-medium leading-tight tracking-tight text-ink">
                {title}
              </h3>
            ) : null}
            {description ? (
              <p className="mt-1 text-sm text-ink-muted">{description}</p>
            ) : null}
          </div>
          {actions ? <div className="shrink-0">{actions}</div> : null}
        </div>
      )}
      {children}
    </div>
  );
}
